'use client';
import { useSuspenseQuery } from '@tanstack/react-query';
import { BiHeart } from 'react-icons/bi';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Container from '@/components/@base/container';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import SeeAllButton from '@/components/app/archive/components/products/theme-demos/see-all-button';
import Props from '@/components/app/archive/components/products/theme-demos/type';
import { ARCHIVE_PAGE_TYPE } from '@/components/app/archive/helpers';
import { getSuggestionDemosListOptions } from '@/components/app/archive/services/hooks';
import Demo from '@/components/shared/components/cards/demo';
import RoundedIcon from '@/components/shared/components/icon/rounded';
import IconTextCombo from '@/components/shared/components/icon-text-combo';

import { pageLevelLocalization } from '@/constant/localization';

const { archive: archiveLocalization } = pageLevelLocalization;

export default function ThemeDemos({ slug = '', type }: Props) {
  const { data } = useSuspenseQuery(getSuggestionDemosListOptions(slug, type));

  if (!data || data.length < 3 || type === ARCHIVE_PAGE_TYPE.SEARCH) {
    return null;
  }

  return (
    <Container className='my-4 bg-[#363942] p-5 md:rounded-md'>
      <Container center className='justify-between pb-6'>
        <IconTextCombo
          Icon={<RoundedIcon icon={<BiHeart color='#fff' />} />}
          textSize={SIZE_ENUM.XL}
          headingType={HEADING_TYPE.H2}
          title={archiveLocalization.themeDemos}
          textClassName='text-white font-medium'
          wrapperClassName='max-w-fit pb-0'
        />
        <SeeAllButton />
      </Container>
      <Container className='mx-0 grid grid-cols-1 gap-4 md:m-0 md:grid-cols-2 lg:grid-cols-3'>
        {data.slice(0, 3).map((demo, index) => (
          <Demo data={demo} key={index} className='mx-auto md:mx-0' />
        ))}
      </Container>
    </Container>
  );
}
